module.exports = __webpack_public_path__ + "static/media/ideals_logo.05897a3b.jpg";